import React from 'react';
import PropTypes from 'prop-types';
import MoveTo from 'moveto';
// import numeral from 'numeral';
import { get } from 'lodash';
// import { GoogleMapUrl, Image } from '@bd/bdcore-utilities';
import { css } from '@bd/bdui-styles/emotion';
// import { Link } from '@bd/bdcore-named-routes';
// import withData from '@bd/bdcore-data';
// import LightBox from '@bd/bdui-lightbox';

// import { colors } from '../styles';

function scrollToTop(ref) {
  setTimeout(() => {
    const moveTo = new MoveTo({
      tolerance: 100,
    });
    moveTo.move(ref);
  }, 100);
}

const styles = css`
  &.Sort_dropdown {
    list-style: none;
    padding: 0;
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    z-index: 100;
    background-color: #fff;
    display: none;
    box-shadow: rgba(0, 0, 0, 0.5) 0px 10px 15px 0px;
    @media(min-width: 992px) {
      top: 87px;
    }
    .Sort_dropdownItemButton {
      width: 100%;
      display: flex;
      height: 45px;
      padding: 0 15px;
      align-items: center;
      font-size: 13px;
      font-weight: 400;
      color: #000000;
      cursor: pointer;
      transition: all .3s ease-out;
      &:hover {
        background-color: #F4F4F4;
      }
    }
    .Sort_dropdownItemButton-active {
      background-color: #F4F4F4;
    }
    .Sort_dropdownItem {
      & + li {
        border-top: 1px solid #D2D2D2;
      }
    }
  }
  &.Sort_dropdownOpen {
    display: block
  }
`;

function SortDropdown({ sortOptions, className, activeSort, scrollRef, onSortSelect }) {
  return (
    <ul className={`${styles} ${className}`}>
      { sortOptions.map(option => (
        <li className="Sort_dropdownItem" key={option.title}>
          <span
            className={`Sort_dropdownItemButton ${get(option, 'title') === get(activeSort, 'title') ? 'Sort_dropdownItemButton-active' : ''}`}
            role="button"
            tabIndex="0"
            onClick={e => {
              e.preventDefault();
              scrollToTop(scrollRef);
              onSortSelect(option);
              // activateMenu();
            }}
          >
            {option.title}
          </span>
        </li>
      ))}
    </ul>
  );
}

SortDropdown.propTypes = {
  sortOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  className: PropTypes.string,
  activeSort: PropTypes.object.isRequired,
  scrollRef: PropTypes.object.isRequired,
  onSortSelect: PropTypes.func.isRequired,
};

SortDropdown.defaultProps = {
  className: '',
};

export default SortDropdown;



// WEBPACK FOOTER //
// ./src/components/SortDropdown.js